// extracted by mini-css-extract-plugin
module.exports = {"container":"GridHalves_container__3IXBZ","cursorDisabled":"GridHalves_cursorDisabled__hd7Ho"};